module.exports = __webpack_public_path__ + "img/program-flower.b719f0fe.png";